import { render, staticRenderFns } from "./OrgpolicyPage.vue?vue&type=template&id=69b08eec"
import script from "./OrgpolicyPage.vue?vue&type=script&lang=js"
export * from "./OrgpolicyPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports